export const environment = {
  production: false,
  API_url: 'http://api.dev.antecipagov.com.br',
};
